import React, {useState} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navigation.css';
import { ReactComponent as LightModeIcon } from '../icons/light-on.svg';
import { ReactComponent as DarkModeIcon } from '../icons/light-off.svg';
import { ReactComponent as MenuIcon } from '../icons/hamburger.svg';
import { useTheme } from '../hooks/useTheme';

function Navigation({ user, onLogout }) {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();
  const [menu, setMenu] = useState(false);

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };


  const toggleMenu = () => {
    setMenu(prev => !prev);
  };


  return (
    <nav className="navbar">
      <div className="nav-container-small">
        <Link to="/" className="nav-logo">
          D&D Calendar
        </Link>
        <button className="btn btn-secondary" onClick={toggleMenu} >
          <MenuIcon className="icon"/>
        </button>
      </div>
      { menu && (
          <div className="menu-container">
            <div className="menu-item">
              <Link to="/" className="nav-link">
                My Calendars
              </Link>
            </div>
            <div className="menu-item nav-link" onClick={toggleTheme}>
              Toggle mode
              <div title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}>
                {theme === 'dark' ? (
                    <LightModeIcon className="icon"/>
                ) : (
                    <DarkModeIcon className="icon"/>
                )}
              </div>
            </div>
            <div className="nav-link" onClick={handleLogout}>
              Logout {user?.username}
            </div>
          </div>
      )
      }

      <div className="nav-container">
        <Link to="/" className="nav-logo">
          D&D Calendar
        </Link>
        <div className="nav-menu">
          <Link to="/" className="nav-link">
            My Calendars
          </Link>
          <button className="theme-toggle" onClick={toggleTheme} title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}>
            {theme === 'dark' ? (
                <LightModeIcon className="icon"/>
            ) : (
                <DarkModeIcon className="icon"/>
            )}
          </button>
          <div className="nav-user">
            {user?.color && (
              <span
                className="nav-user-dot"
                style={{ backgroundColor: user.color }}
                title={user.username}
              >
                {(user.username || '?')[0].toUpperCase()}
              </span>
            )}
            <span className="user-name">{user?.username}</span>
            <button onClick={handleLogout} className="btn btn-secondary btn-sm">
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;
